import { render } from "./appFooter.vue?vue&type=template&id=193de060&scoped=true"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"

import "./appFooter.vue?vue&type=style&index=0&id=193de060&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193de060"]])

export default __exports__